module.exports = __webpack_public_path__ + "static/media/telegram-logo.e6a1c6e6.png";